import gql from 'graphql-tag';

export const GET_LATEST_NOTIFICATIONS = gql`
	query getLatestPhoneNotifications {
		getLatestNotifications {
			id
			content
			created
			status
			checklistSubmissionId
		}
	}
`;

export const NOTIFICATION_TOGGLE_READ = gql`
	mutation markPhoneNotificationRead($id: ID!) {
		notificationToggleRead(id: $id) {
			id
			status
		}
	}
`;
